import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

export const isPhoneConference = (conference?: Nullable<ConferenceApiModel>) =>
  conference?.type === 'phone';
